import 'reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

export class FixedTypeModel extends Serializable {
  @jsonProperty(Number, null) id: number | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(String, null) notes: string | null = null;
}
